import { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Screen } from '../../styles';
import { HashLink } from 'react-router-hash-link';

const Timer = ({ meetingLinks, banner, date }) => {
    const countDownDate = new Date(date).getTime()
    // const countDownDate = new Date("Jan 24 2025").getTime()
    const [countDown, setCountDown] = useState();
    const [numberInDays, setNumberInDays] = useState("")
    const mounted = useRef()

      useEffect(() => {
        mounted.current = true
        const interval = setInterval(() => {
            setCountDown(countDownDate - new Date().getTime())
        }, 1000)

        setNumberInDays(Math.floor(countDown / (1000 * 60 * 60 * 24)) + 1)

        return () => {
            clearInterval(interval)
            mounted.current = false
        }
      }, [countDown])
  return (
    <Box>
        <Image src={banner} alt={'flier'} />
        <CountDownContainer className='counter'>
            {numberInDays > 1 && `${numberInDays} days to go`}
            {numberInDays === 1 && `A day to go`}
            {numberInDays === 0 && "We're Live!"}
            {numberInDays < 0 && ""}
        </CountDownContainer>
        <div style={{ marginTop: '20px'}}>
        {
          numberInDays >= 0 && (
            <ButtonWrapper>
              {
                meetingLinks.length && meetingLinks.map((meeting) => (
                  <MeetingLink key={meeting?.link} to={meeting?.link} target='_blank' rel='noreferer'>
                    <CountDownContainer className='button'>{meeting?.link?.includes('youtube') ? 'Join on Youtube here' : 'Join on Zoom here'}</CountDownContainer>
                  </MeetingLink>
                ))
              }
            </ButtonWrapper>
          )
        }
        </div>
    </Box>
  )
}

const Box = styled.div`
width: 100%;

${Screen.tablet`
margin: 5rem auto;
width: 80%;
`}
${Screen.mediumPhone`
width: 100%;
margin-top: 3rem
`}
`
const CountDownContainer = styled.div`
width: 100%;
padding: 1rem;
background-color: #002668;
text-transform: uppercase;
font-size: 30px;
color: #fff;
text-align: center;
font-weight: 600;
margin-top: -4px;
cursor: pointer;

&.button {
  width: 40%;
  border-radius: 10px;
  width: 100%;
  padding: 1rem;
  background-color: #002668;
  text-transform: uppercase;
  font-size: 30px;
  color: #fff;  
  text-align: center;
  font-weight: 600;
  margin-top: -4px;
  cursor: pointer;
}

&:hover {
  background-color: #0d3375;
}

&.counter {
  pointer-events: none;
}

&.disabled {
  pointer-events: none!important;
  background-color: #DBE8FE;
  &:hover {
    background-color: #DBE8FE;
  }
}

${Screen.mediumPhone`
font-size: 20px;
`}
`;

const Image = styled.img`
width: 100%;
margin-bottom: 0;
`;

const MeetingLink = styled(HashLink)`
text-decoration: none;

&.disabled {
  pointer-events: none!important;
}
`;

const ButtonWrapper = styled.div`
width: 100%;
display: flex;
gap: 20px;
justify-content: center;
`

export default Timer
